import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const ConfirmationModal = ({
    show,
    onHide,
    handleFunction,
    displayText
}) => {
    const onClose = () => {
        onHide()
    }

    const onConfirmation = () => {
        handleFunction()
    }
    return (
        <Modal
            size='md'
            show={show}
            onHide={onClose}
            centered
        >
            <Modal.Body>
                <>
                    <p className='modal-description mt-4'>
                        {displayText}
                    </p>
                </>
            </Modal.Body>
            <Modal.Footer>
                <>
                    <Button
                        className='select-btn h-40'
                        variant='brown'
                        onClick={onConfirmation}
                    >
                        OK
                    </Button>
                </>
            </Modal.Footer>
        </Modal>
    )
}

export default ConfirmationModal
